var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoInternetConnection(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "no-connectivity",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff000f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#f30410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#e90512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#e00612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#d90713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#d40713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d00814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#ce0814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#cc0814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc0814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a5a2a",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#985929",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#965728",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#925527",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#8e5225",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#894f22",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#834b1f",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#7c461c",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#744118",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c3b13",
    stopOpacity: 0.902
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc0814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#cc0814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#ce0814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d00814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#d40713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#d90713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e00612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e90512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#f30410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff000f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a5a2a",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#995929",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#955728",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#8f5325",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#894f22",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#814a1f",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#7a441b",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#734017",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#6e3c14",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c3b13",
    stopOpacity: 0.902
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.5,
    y1: 0.003,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f1f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NoInternet",
    transform: "translate(0 2.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M255,132.923c6.354,28.141-18.588,64.345-46.226,82.177-27.6,17.782-57.943,17.153-84.791,16.776l-7.459-.121c-23.814-.433-45-1.577-65.6-12.025C28.2,208.2,6.283,185.253,1.2,157.32c-5.075-27.693,6.4-60.229,25.455-86.484l.58-.794c19.356-26.431,46.4-46.3,71.98-46.04s49.872,20.622,80.792,40.758l3.708,2.4C213.906,86.525,248.862,105.945,255,132.923Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(35.205 19.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M106.5,153.591l.013.833.007.886v.942a216.567,216.567,0,0,1-8.56,56.333l-1.575-.013h0l-1.259-3.594-.849-3.317q-9.261-36.378-10.093-49.516Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M85.1,153.964l.008.539.017.55q.532,13.778,11.932,57.524c-2.793-.023-5.556-.064-8.283-.1l-7.459-.121c-6.758-.123-13.3-.3-19.686-.737l-.31-.977a223.775,223.775,0,0,1-6.874-26.44,135.891,135.891,0,0,1-2.1-24.411Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M133.637,130.115c1.5.844,2.573,1.313,4.021,2.155l1.761,1.032q39.772,23.449,53.771,46.152-1.178,1.214-2.384,2.391-13.431-22.5-54.113-46.345l-.953-.553h0l-1.346-.767-2.351-1.322Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M111.94,64.455c9.559,4.355,22.6,54.8,23.907,59.557l.16.57c1.306,4.548,3.157,8.807.326,11.206-1,.847-5.994,2.861-7.861,1.026s-.617-5.59,1.109-5.871l.369-.066c4.055-.792-2.857-2.134-3.388-7.307l-.018-.221q-.351-5.328-4.836-12.954l-.3-.511L114,96.777c-5.484-9.764-10.982-13.3-14.78-17.8C91.608,69.959,102.382,60.1,111.94,64.455Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M111.94,64.455c9.559,4.355,22.6,54.8,23.907,59.557l.16.57c1.306,4.548,3.157,8.807.326,11.206-1,.847-5.994,2.861-7.861,1.026s-.617-5.59,1.109-5.871l.369-.066c4.055-.792-2.857-2.134-3.388-7.307l-.018-.221q-.351-5.328-4.836-12.954l-.3-.511L114,96.777c-5.484-9.764-10.982-13.3-14.78-17.8C91.608,69.959,102.382,60.1,111.94,64.455Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M74.077,50.037c9.01,0,24.708,2.468,33.45,6.575s16.908,23.159,16.564,23.672q-.345.513-16.512,10.6-1.137,13.141-1.137,19.169c0,6.029,2.363,42.4,1.075,43.49s-7.835,4.83-23.4,8.544q-10.038,2.4-32.807,0,2.315-33.722.91-48.361c-1.4-14.64-9.827-46.7-3.78-54.964C52.471,53.253,65.067,50.037,74.077,50.037Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M107.809,123.7a.993.993,0,0,1,.433.391,1.57,1.57,0,0,1,.19.832l.013.238,2.181-.114a.546.546,0,0,1,.057,1.09l-2.181.115.171,3.271,2.181-.114a.546.546,0,1,1,.057,1.09l-2.181.115.013.237a1.586,1.586,0,0,1-.1.848.994.994,0,0,1-.39.434,1.379,1.379,0,0,1-.682.18l-4.989.263c-.062,0-.119.006-.172.007l-.135.009a4.369,4.369,0,0,1-4.095-2.327h-.049c-44.689.279-73.883,15.262-87.878,44.911l-1.544,3.464q-2.772,6.238-6.04,13.707Q1.323,191.382,0,190.361l2.779-6.4c2.078-4.749,3.992-9.065,4.074-9.244,14.384-31.467,44.8-47.364,90.952-47.728l.052,0a4.37,4.37,0,0,1,3.96-3.118l5.145-.269A1.579,1.579,0,0,1,107.809,123.7Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M42.278,73.574c-3.233,6.964-5.262,35.8-3.173,38.988S60.793,125.214,68.09,128.1s19.731,5.113,22.013,5.113A26.339,26.339,0,0,0,97,132.244l.181-.114c.421-.283.362-.439.211-1.394-.17-1.075-2.888-.479-5-.54-.919-.027-2.6-1.279-2.289-2.1s4.09-.519,4.807-1.058c.423-.318.371-1.091-.322-1.535-.481-.308-5.16-.14-7.731-.671l-.123-.033c-1.455-.43-11.241-4.364-14.245-6.864l-2.287-1.49q-12.321-8.067-13.782-10.008C55,104.557,60.554,83.22,59.7,80.908l-.159-.215C56.835,77.149,45.212,67.254,42.278,73.574Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M42.278,73.574c-3.233,6.964-5.262,35.8-3.173,38.988S60.793,125.214,68.09,128.1s19.731,5.113,22.013,5.113A26.339,26.339,0,0,0,97,132.244l.181-.114c.421-.283.362-.439.211-1.394-.17-1.075-2.888-.479-5-.54-.919-.027-2.6-1.279-2.289-2.1s4.09-.519,4.807-1.058c.423-.318.371-1.091-.322-1.535-.481-.308-5.16-.14-7.731-.671l-.123-.033c-1.455-.43-11.241-4.364-14.245-6.864l-2.287-1.49q-12.321-8.067-13.782-10.008C55,104.557,60.554,83.22,59.7,80.908l-.159-.215C56.835,77.149,45.212,67.254,42.278,73.574Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M59.7,55.143l.392.186c4.2,2.07,9.009,6.92,4.87,21.18l-.407,1.382C63.149,82.757,61.7,88.952,61,92.052L60.569,94s-1.639,1.823-8.644,1.316A41.594,41.594,0,0,1,36.8,90.872l.378-2.174c1.118-6.21,4.579-23.869,8.517-28.43C50.495,54.7,55.376,53.161,59.7,55.143Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M120.552,128.246c.7-2.621,2.689-4.367,4.436-3.9a2.124,2.124,0,0,1,.294.1l-.025-.006a26.8,26.8,0,0,1,5.96,2.768c1.467.882,1.652,2.654,1.266,4.186s-1.132,3.213-2.933,3.043l-6.318-.533a2.254,2.254,0,0,1-.788-.066C120.7,133.372,119.85,130.868,120.552,128.246Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M93.814,50.532l-1.044,3.895h0a114.323,114.323,0,0,1-3.687,11.192,35.6,35.6,0,0,1-10.341-6.851,16.069,16.069,0,0,1-4.505-9.151,121.492,121.492,0,0,0,2.86-17.76c-3.056-7.281-1.672-11.247,1.645-13.408q11.112-7.241,33.544,2.249Q108.2,44.644,101.43,50.138,98.529,52.491,93.814,50.532Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M93.814,50.532l-1.044,3.895h0a114.323,114.323,0,0,1-3.687,11.192,35.6,35.6,0,0,1-10.341-6.851,16.069,16.069,0,0,1-4.505-9.151,121.492,121.492,0,0,0,2.86-17.76c-3.056-7.281-1.672-11.247,1.645-13.408q11.112-7.241,33.544,2.249Q108.2,44.644,101.43,50.138,98.529,52.491,93.814,50.532Z",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M83.432,43.4a24.107,24.107,0,0,0,9.87,6.92l.527.215a.012.012,0,0,1-.014,0l-1.09,4.062A18.717,18.717,0,0,1,83.432,43.4Z",
    fill: "#6c3b13",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M84.895,22.555c-.787-1.161-2.525-2.255-4.142-1.11-2.51,1.778-4.124,9.718-.656,10.93l.184.057c.967.259,1.114,3.79-3.764,4.773,0-1.769-1.282-6.033-1.882-10.628a33.394,33.394,0,0,1,.726-10.628C70.69,12.611,74.066,5.17,77.63,6.125c1.343-7.292,13.68-7.936,16.977-2.664,5.914-4.2,16.456,1.586,15.884,6.448,8.874-2.092,9.737,10.291,1.227,13l-.367.112c-3.48,1.007-8.4,1.032-18.145-1.579l-.326-.08c-1.407-.311-2.741-.14-3.483,1.54-.8,1.809.332,3.68-2.108,3.677S86.054,24.992,84.895,22.555Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-11)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 256,
    height: 256,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternetConnection);
export default __webpack_public_path__ + "static/media/NoInternetConnection.c1f18835655f046d0568c114b1371dc0.svg";
export { ForwardRef as ReactComponent };